import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Check, AlertCircle } from "lucide-react";
import { useWorkflow } from "../../../../context/WorkflowContext";

export default function TriggerTestDataSection() {
    const { t } = useTranslation();
    const { testData, setTestData } = useWorkflow();
    const [value, setValue] = useState("");
    const [error, setError] = useState(null);
    const [saved, setSaved] = useState(false);
    const timerRef = useRef(null);
    const userEditedRef = useRef(false);

    useEffect(() => {
        if (!userEditedRef.current) {
            setValue(JSON.stringify(testData || {}, null, 2));
        }
    }, [testData]);

    const handleChange = useCallback((e) => {
        const raw = e.target.value;
        userEditedRef.current = true;
        setValue(raw);
        setError(null);
        setSaved(false);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            try {
                const parsed = JSON.parse(raw);
                if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
                    setError(t("chatInput.mustBeJsonObject"));
                    return;
                }
                setTestData(parsed);
                setSaved(true);
                setTimeout(() => setSaved(false), 2000);
            } catch {
                setError(t("chatInput.invalidJson"));
            }
        }, 800);
    }, [setTestData, t]);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    return (
        <div className="px-4 py-3 border-t border-gray-200">
            <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-medium text-gray-700">{t("chatInput.testData")}</span>
                <div className="flex items-center gap-1">
                    {saved && <Check size={12} className="text-green-500" />}
                    {saved && <span className="text-[10px] text-green-500">{t("chatInput.saved")}</span>}
                    {error && <AlertCircle size={12} className="text-red-400" />}
                    {error && <span className="text-[10px] text-red-400">{error}</span>}
                </div>
            </div>
            <textarea
                value={value}
                onChange={handleChange}
                spellCheck={false}
                className="w-full h-[160px] text-[11px] font-mono bg-gray-50 border border-gray-200 rounded p-2 resize-y focus:outline-none focus:border-blue-300 text-gray-700"
                placeholder='{ "key": "value" }'
            />
            <p className="text-[10px] text-gray-400 mt-1">{t("chatInput.testDataHelp")}</p>
        </div>
    );
}
